import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import Title from '@oberoninternal/travelbase-ds/components/primitive/Title';
import { getFontCss } from '@oberoninternal/travelbase-ds/constants/theme';
import Body from '@oberoninternal/travelbase-ds/components/primitive/Body';

interface Props {
    title: ReactNode;
    description: ReactNode;
}

const EmptyState: FC<React.PropsWithChildren<Props>> = ({ title, description }) => (
    <EmptyStateWrapper>
        <EmptyStateTitle>{title}</EmptyStateTitle>
        <div>
            <EmptyStateHelper>{description}</EmptyStateHelper>
        </div>
    </EmptyStateWrapper>
);
export default EmptyState;

const EmptyStateWrapper = styled.div`
    padding-top: 10.3rem;
    text-align: center;
`;

const EmptyStateTitle = styled(Title)`
    ${({ theme }) => getFontCss(theme.fontSizes.title.large)};
    padding-bottom: 1.6rem;
`;

const EmptyStateHelper = styled(Body)`
    ${({ theme }) => getFontCss(theme.fontSizes.body.regular)};
`;
